export default function HowWePriceSection() {
  const steps = [
    {
      number: '1',
      icon: 'ri-message-3-line',
      title: 'Tell Us What You Want',
      description: 'Share your budget, must-haves, and deal-breakers. We listen first, then get to work.'
    },
    {
      number: '2',
      icon: 'ri-search-line',
      title: 'We Source from the Dealer Network',
      description: 'We search inventory across multiple dealerships to find the exact vehicle that matches your criteria.'
    },
    {
      number: '3',
      icon: 'ri-hand-coin-line',
      title: 'We Negotiate on Your Behalf',
      description: 'Our team handles all the back-and-forth with dealers so you don\'t have to. No haggling required.'
    },
    {
      number: '4',
      icon: 'ri-file-list-3-line',
      title: 'You See the Full Itemized Price',
      description: 'Before you commit, we show you every line item — dealer cost, fees, taxes, and our flat broker fee.'
    },
    {
      number: '5',
      icon: 'ri-check-double-line',
      title: 'One Flat Fee — No Surprises',
      description: 'Our $995 broker fee is disclosed upfront. No hidden charges, no last-minute add-ons at signing.'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-price-tag-3-line text-lg"></i>
            <span>Transparent Pricing</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            How Our Pricing Works
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            No hidden fees, no surprise charges. Here's exactly how we price every deal from start to finish.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 border border-slate-200 hover:border-teal-300 hover:shadow-lg transition-all duration-300 group"
            >
              {/* Step Number Badge */}
              <div className="flex items-start gap-4 mb-4">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-lg flex items-center justify-center text-white font-bold text-lg shadow-md group-hover:scale-110 transition-transform duration-300">
                  {step.number}
                </div>
                <div className="flex-shrink-0 w-12 h-12 bg-slate-100 rounded-lg flex items-center justify-center group-hover:bg-teal-50 transition-colors duration-300">
                  <i className={`${step.icon} text-2xl text-slate-600 group-hover:text-teal-600 transition-colors duration-300`}></i>
                </div>
              </div>

              {/* Content */}
              <h3 className="text-lg font-bold text-slate-900 mb-2">
                {step.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}

          {/* Flat Fee Callout Card */}
          <div className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl p-6 text-white shadow-xl md:col-span-2 lg:col-span-1 flex flex-col justify-center items-center text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-4">
              <i className="ri-price-tag-3-fill text-3xl"></i>
            </div>
            <div className="text-5xl font-bold mb-2">$995</div>
            <div className="text-lg font-semibold mb-2">Flat Broker Fee</div>
            <p className="text-sm text-white/90 leading-relaxed">
              That's it. No percentage markups, no dealer pack fees, no surprise charges at the finance desk.
            </p>
          </div>
        </div>

        {/* Bottom Callout */}
        <div className="bg-slate-900 rounded-xl p-8 text-center">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-3">
              Every Line Item. Every Time.
            </h3>
            <p className="text-slate-300 text-lg mb-6">
              Before you sign anything, you'll see a complete breakdown of dealer cost, our fee, taxes, and registration. No fine print, no "we'll explain later" — just honest numbers from the start.
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <div className="flex items-center gap-2 text-emerald-400">
                <i className="ri-check-line text-lg"></i>
                <span>Dealer invoice price shown</span>
              </div>
              <div className="flex items-center gap-2 text-emerald-400">
                <i className="ri-check-line text-lg"></i>
                <span>All fees itemized upfront</span>
              </div>
              <div className="flex items-center gap-2 text-emerald-400">
                <i className="ri-check-line text-lg"></i>
                <span>No last-minute add-ons</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}